var agregarFechaPospuesta = (diasAgregados) => {
    Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    var date = new Date();
    var year = 1900 + date.addDays(diasAgregados).getYear();
    var month = date.addDays(diasAgregados).getMonth() + 1;
    var day = date.addDays(diasAgregados).getDate()
    month = month < 10 ? `0${month}` : `${month}`;
    day = day < 10 ? `0${day}` : `${day}`
    return `${year}-${month}-${day}`
}

export default agregarFechaPospuesta;